module.exports = __webpack_public_path__ + "img/Monte_Kope_65.1347a00e.jpg";